<template>
    <div class="project-card">
        <div class="card-header">
            <div class="card-title" :title="card.title">{{ card.title }}</div>
            <div class="project-type">{{ card.type }}</div>
        </div>
        <div class="card-content">
            <img :src="$commonPicUrl + card.imageUrl" width="220px" height="140px">
            <div class="detail" :title="card.detail">
                {{ card.detail }}
            </div>
        </div>
        <div class="card-bottom">
            <div class="card-address" :title="card.address">
                <i class="el-icon-location-outline" style="font-size: 20px;"></i>
                {{ card.address }}
            </div>
            <div class="card-link">
                <a v-for="link in card.links" :key="link.title" @click="openNew(link, card)">
                    {{ link.title }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getToken } from "../utils/token";
import { getUsername } from "../utils/getUsernameForCloud";
import { createUuid } from "../utils/getUuid"
export default {
    name: 'componentCard',
    computed: {
        ...mapGetters(['getUserName']),
    },
    props: {
        card: {
            default: () => { },
            type: Object,
        }
    },
    data() {
        return {
            messageListener: null,
            timers: new Map(),
        }
    },
    methods: {
        // 启动定时器
        startTimer(id, link, card) {
            if (this.timers.has(id)) {
                console.warn(`定时器 ${id} 已存在`);
                return;
            }
            const Authorization = getToken() || "";
            const username = getUsername() || "";
            const newWindow = window.open(`${link.url}?timerId=${id}`, '_blank');
            const intervalId = setInterval(() => {
                if (newWindow && !newWindow.closed) {
                    let data = {
                        Authorization: Authorization,
                        // uuid: "02755c6b11434a0aa9081b3bf11c63fa",
                        // userId: 2,
                        username: username,
                        uuid: card.uuid,
                        userId: card.userId,
                        timerId: id,
                    };
                    // console.log("发送消息。。。", data)
                    // 发送消息
                    newWindow.postMessage(data, link.url);
                }
            }, 100);
            this.timers.set(id, intervalId);
            // console.log(`定时器 ${id} 已启动`);
        },
        // 关闭指定定时器
        stopTimer(id) {
            const intervalId = this.timers.get(id);
            if (intervalId) {
                clearInterval(intervalId);
                this.timers.delete(id);
                // console.log(`定时器 ${id} 已关闭`);
            } else {
                console.warn(`未找到定时器 ${id}`);
            }
        },
        // 关闭所有定时器
        stopAllTimers() {
            this.timers.forEach((intervalId) => {
                clearInterval(intervalId);
            });
            this.timers.clear();
            console.log('所有定时器已关闭');
        },
        getAppDetails() {
            this.$emit("click", this.card);
        },
        openNew(link, card) {
            if (link.type === 'digital') {
                window.open(link.url, '_blank');
            } else if (link.type === 'master') {
                let id = createUuid();
                this.startTimer(id, link, card);
            }
        },
        // openNew(link, card) {
        //     // if (link.type === 'digital') {
        //     //     window.open(link.url, '_blank');
        //     // } else
        //     if (link.type) {
        //         const Authorization = getToken() || "";
        //         const username = getUsername() || "";
        //         const newWindow = window.open(link.url, '_blank');
        //         this.interval = setInterval(() => {
        //             if (newWindow && !newWindow.closed) {
        //                 let data = {
        //                     Authorization: Authorization,
        //                     uuid: "02755c6b11434a0aa9081b3bf11c63fa",
        //                     userId: 2,
        //                     username: username,
        //                     // uuid: card.uuid,
        //                     // userId: card.userId,
        //                 };
        //                 console.log("发送消息。。。", data)
        //                 // 发送消息
        //                 newWindow.postMessage(data, link.url);
        //             }
        //         }, 2000); // 每 2秒 尝试一次，直到发送成功或窗口关闭
        //     }
        // },
    },
    mounted() {
        // 将监听函数定义为一个独立方法或变量
        this.messageListener = (event) => {
            // console.log("传回消息。。。。。。。", event.data)
            if (event.data.timerId) {
                this.stopTimer(event.data.timerId);
            }
        };

        // 添加事件监听
        window.addEventListener('message', this.messageListener);
    },
    beforeDestroy() {
        // 必须传入相同的函数引用
        if (this.messageListener) {
            window.removeEventListener('message', this.messageListener);
        }
    }
}
</script>

<style scoped lang="less">
.card-link {
    color: #2066FF;

    .link {
        cursor: pointer;
        text-decoration: underline;
    }

    a {
        color: #2066FF;
        text-decoration: underline;
        cursor: pointer;
    }

    a:last-child {
        margin-left: 30px;
    }
}

.project-card:nth-child(3n-1) {
    margin: 10px 31.5px;
}

.project-card {
    margin: 10px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 600px;
    height: 260px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 16px;
    padding: 15px 20px;
    background-color: #fff;

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 37px;
    }

    .card-title {
        width: calc(100% - 100px);
        font-size: 20px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #333;
        text-align: left;
    }

    .project-type {
        width: 80px;
        height: 30px;
        line-height: 30px;
        background-color: #D2E6FF;
        color: #2066FF;
        border-radius: 20px;
    }

    .detail {
        width: calc(100% - 230px);
        height: 140px;
        margin-left: 10px;
        text-align: justify;
        display: -webkit-box;
        /* 使用弹性盒子布局 */
        -webkit-box-orient: vertical;
        /* 内容垂直排列 */
        -webkit-line-clamp: 6;
        /* 限制显示行数为3行 */
        overflow: hidden;
        /* 隐藏溢出内容 */
        text-overflow: ellipsis;
        /* 显示省略号 */
        overflow-wrap: break-word;
        /* 优先在词间断行，必要时在词内 */
    }

    .card-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .card-address {
            width: 63%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            text-align: left;
        }
    }

    .card-content {
        display: flex;
        align-items: stretch;
    }

    .developer {
        width: 250px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>